var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCardTwo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 32,
    viewBox: "0 0 53 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5223 7.60225L23.7701 10.1501C23.1519 10.3496 22.4812 10.3086 21.8919 10.0352C21.3026 9.76192 20.8381 9.27638 20.5911 8.67558C20.344 8.07478 20.3327 7.40292 20.5593 6.79413C20.786 6.18534 21.2339 5.68442 21.8136 5.39138L29.3245 1.63704C29.9652 1.31904 30.6638 1.13463 31.378 1.09501C32.0921 1.0554 32.8069 1.16141 33.4788 1.4066L44.5658 5.42834V20.6457L31.5093 23.1262",
    stroke: "#6263AB",
    strokeWidth: 2.17391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.60913 20.646H13.0439L20.8483 29.3938C21.2453 29.855 21.7739 30.1835 22.3632 30.3354C22.9525 30.4872 23.5741 30.4551 24.1446 30.2432C24.715 30.0314 25.2069 29.65 25.5543 29.1503C25.9016 28.6507 26.0876 28.0567 26.0874 27.4481V26.0808L26.4765 26.2373C27.0349 26.4603 27.6394 26.5431 28.2372 26.4785C28.835 26.4139 29.4078 26.2039 29.9056 25.8667C30.4035 25.5295 30.8111 25.0755 31.0929 24.5444C31.3747 24.0132 31.5221 23.4212 31.5222 22.8199H32.6091C33.2147 22.8199 33.8083 22.6513 34.3235 22.3329C34.8386 22.0145 35.2549 21.559 35.5257 21.0173C35.7966 20.4757 35.9112 19.8693 35.8568 19.2662C35.8024 18.663 35.5812 18.087 35.2178 17.6025L28.2613 8.68945",
    stroke: "#6263AB",
    strokeWidth: 2.17391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.9396 4.81757L22.1439 4.16539C21.5058 3.69261 20.7574 3.39072 19.9699 3.28838C19.1823 3.18603 18.3817 3.28663 17.6439 3.58061L7.60913 7.60235",
    stroke: "#6263AB",
    strokeWidth: 2.17391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08691 3.25439H5.43474C6.0113 3.25439 6.56424 3.48343 6.97193 3.89112C7.37962 4.29881 7.60865 4.85175 7.60865 5.42831V20.6457C7.60865 21.2223 7.37962 21.7752 6.97193 22.1829C6.56424 22.5906 6.0113 22.8196 5.43474 22.8196H1.08691",
    stroke: "#6263AB",
    strokeWidth: 2.17391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0864 22.8196H46.7386C46.1621 22.8196 45.6091 22.5906 45.2014 22.1829C44.7937 21.7752 44.5647 21.2223 44.5647 20.6457V5.42831C44.5647 4.85175 44.7937 4.29881 45.2014 3.89112C45.6091 3.48343 46.1621 3.25439 46.7386 3.25439H51.0864",
    stroke: "#6263AB",
    strokeWidth: 2.17391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0868 26.0807L23.9128 23.9067",
    stroke: "#6263AB",
    strokeWidth: 2.17391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.261 19.5586L31.5219 22.8195",
    stroke: "#6263AB",
    strokeWidth: 2.17391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardTwo);
export default __webpack_public_path__ + "static/media/icon-card-two.a18027b3f5bc26da4811e02901007c87.svg";
export { ForwardRef as ReactComponent };